import Route from '@ember/routing/route';
import { service } from '@ember/service';

export default class AdminCategoriesNewRoute extends Route {
  // Services
  @service breadcrumb;

  // Hooks
  model() {
    return this.breadcrumb.findRouteModelOrCreateRecord('category');
  }

  afterModel(model) {
    this.breadcrumb.registerDetailRoute(model);
  }
}
